import React from 'react'

interface IStoreeAvatarProps {
  size?: number | string
}

export function StoreeAvatar({ size = 34 }: IStoreeAvatarProps) {
  return (
    <img
      src="/storee-doll-512.png"
      alt=""
      draggable={false}
      style={{ display: 'block', width: size, height: size, flexShrink: 0, objectFit: 'contain' }}
    />
  )
}
